import getFormattedNumber from "@src/shared/utils/getFormattedNumber";

import { ReactSelectOptions } from "../../../types";

type DocumentFacet = { slug: string; name: string; count: number };

export function convertToSelectOptions(documentCount?: DocumentFacet[] | null): ReactSelectOptions<any>[] {
    if (documentCount == null) {
        return [];
    }

    const options = [];
    for (const documentFacet of documentCount) {
        if (documentFacet.slug.length > 0) {
            const option: ReactSelectOptions<any> = {
                value: `${documentFacet.slug}`,
                label: `${documentFacet.name} (${getFormattedNumber(documentFacet.count)})`,
            };
            options.push(option);
        }
    }

    return options;
}
